// The share page's link for a finished play (Sharing): asked of the Worker the
// first time, then kept for the session, since a play has exactly one share.
// The ?s=share tag lets the Worker count the clicks it brings.
import { api } from '../api/client';

const links = new Map<string, Promise<string>>();

export function shareLink(playId: string, origin = window.location.origin): Promise<string> {
  let link = links.get(playId);
  if (!link) {
    link = api.sharePlay(playId).then((share) => `${origin}${share.path}?s=share`);
    // A failed request is not remembered, so the next tap asks again.
    link.catch(() => links.delete(playId));
    links.set(playId, link);
  }
  return link;
}
